import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import api from '@utils/api'
import { BBDTag, GraviGrid } from '@gravitate-js/excalibrr'
import './payroll_config.css'
import { PayConfigDetail } from './Detail/PayConfigDetail'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { triggerGridRead } from '@utils/general'
import { usePayrollConfig } from '@api/usePayrollConfig'
import { useUserSettings } from '@hooks/settings'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'automatic-payroll-config'

export const PayrollConfig = () => {
  const gridReference = useRef(null)
  const { usePayrollConfigQuery, useUploadAutomaticPayConfigs } = usePayrollConfig()
  const { data: payrollConfig, status } = usePayrollConfigQuery()
  const triggerRefresh = (updatedRecord) => triggerGridRead(gridReference, updatedRecord)
  const { mutateAsync: uploadPayrollConfigs } = useUploadAutomaticPayConfigs()
  const { updateSetting } = useUserSettings()

  const columnDefs = useMemo(() => getColumnDefs(), [])
  const getRowId = useCallback((row) => row.data?.id, [])
  const agPropOverrides = useMemo(
    () => ({
      getRowId,
      rowSelection: 'single',
    }),
    []
  )

  return (
    <>
      <GraviGrid
        controlBarProps={{
          title: 'Automatic Pay Config',
          actionButtons: (
            <UploadDownloadButtons
              excelOptions={[
                {
                  title: 'Download Payroll Configs',
                  downloadEP: api.downloadPayrollConfigs,
                  fileName: 'PayrollConfigs.xlsx',
                },
                {
                  title: 'Upload Payroll Configs',
                  uploadEP: uploadPayrollConfigs,
                },
                {
                  title: 'Download Lane Rates',
                  downloadEP: api.exportPayLaneRates,
                  fileName: 'Lane Rates.xlsx',
                },
                {
                  title: 'Upload Lane Rates',
                  uploadEP: api.importPayLaneRates,
                },
              ]}
              fileName='PayrollConfigs.xlsx'
              refreshCallback={triggerRefresh}
            />
          ),
        }}
        loading={status === 'pending'}
        agPropOverrides={agPropOverrides}
        columnDefs={columnDefs}
        detailCellRenderer={({ data }) => <PayConfigDetail details={data.details} />}
        rowGroupPanelShow='never'
        masterDetail
        isRowMaster={(data) => data.extra_fields?.length !== 0}
        storageKey={STORAGE_KEY}
        rowData={payrollConfig?.rows}
        detailRowAutoHeight
        onGridConfigChanged={(config) => updateSetting(`gridConfig::${STORAGE_KEY}`, config)}
        {...gridViewManager(STORAGE_KEY, updateSetting)}
      />
    </>
  )
}

const getColumnDefs = () => [
  {
    headerName: '',
    field: 'name',
    cellRenderer: 'agGroupCellRenderer',
    valueFormatter: () => '',
    maxWidth: 50,
  },
  {
    headerName: 'Name',
    field: 'name',
    cellRenderer: ({ value }) => <b>{value}</b>,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: ({ value }) => {
      return value.toLowerCase() === 'active' ? (
        <BBDTag style={{ maxWidth: '100px' }} theme2>
          {value}
        </BBDTag>
      ) : (
        <BBDTag style={{ maxWidth: '100px' }}>{value}</BBDTag>
      )
    },
  },
]
